import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable, catchError, of, throwError } from 'rxjs';
import {
  DocumentDetailsEntity,
  DocumentDetailsRedirectResponse,
  isDocumentDetailsRedirectResponse,
} from '../state/document-details.models';

@Injectable({
  providedIn: 'root',
})
export class DocumentDetailsService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getDocumentDetails(
    categoryId: number,
    documentId: number,
    language: string,
  ): Observable<DocumentDetailsEntity | DocumentDetailsRedirectResponse> {
    const url = `${this.apiData.apiURL}api/${this.client}/category/${categoryId}/document/${documentId}/${language}`;

    return this.http.get<DocumentDetailsEntity | DocumentDetailsRedirectResponse>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        // 301 case: HttpClient treats non-2xx as an error, so the {success:false, category_ids} body
        // must be read from error.error and re-emitted as a normal value instead of being swallowed
        if (isDocumentDetailsRedirectResponse(error.error)) {
          return of(error.error);
        }
        console.error('Error fetching document:', error);
        return throwError(() => new Error('Failed to load document'));
      }),
    );
  }
}
